import DeveloperPortal from 'src/views/homepage/CustomTopBar/DeveloperPortal'
import pathMap from 'src/paths/pathMap'

class DeveloperPortalRoute {
    getConfigurations() {
      return [
        {
          exact: true,
          path: pathMap.DEVELOPER_PORTAL,
          component: DeveloperPortal
        }
      ]
    }
  }
  
  export default DeveloperPortalRoute
